import './CadastroMetas.css'

import Select from 'react-select';
import CustomMultiSelectGroup from '../CustomMultiSelectGroup/CustomMultiSelectGroup'
import { useEffect, useRef, useState } from 'react';
import { get, post } from '../../services/api';
import { logout } from '../../auth';
import { useNavigate } from 'react-router-dom';
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';

import { Tooltip } from 'react-tooltip'
import imagemExemplo from '../../assets/img/exemplo-arquivo-metas.png'

import CopyAllIcon from '@mui/icons-material/CopyAll';
import ToolTipFiliaisDesabilitadas from '../ToolTipFiliaisDesabilitadas/ToolTipFiliaisDesabilitadas';

import CheckIcon from '@mui/icons-material/Check';
import BlockIcon from '@mui/icons-material/Block';

import SettingsSystemDaydreamIcon from '@mui/icons-material/SettingsSystemDaydream';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'

function CadastroMetas({ setNotifier }) {
    const navigate = useNavigate()

    const TIPO_GERENTE = 1;
    const TIPO_VENDEDOR = 2;

    const ID_GIRAFA = 4;
    const ID_HIPOPOTAMO = 6;
    const ID_JAGUAR = 7;
    const ID_SURICATO = 10;

    const [ authTokenState, setAuthTokenState ] = useState(null)
    
    const niveis = [ 'A', 'B', 'C', 'D', 'E' ]
    const semMetaBaseSistema = [ ID_HIPOPOTAMO, ID_SURICATO ]
    const animaisCopiaveis = [ ID_GIRAFA, ID_HIPOPOTAMO ];

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    const [ optionsTipos, setOptionsTipos ] = useState([])
    const [ optionsAnimais, setOptionsAnimais ] = useState([])
    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    const currentDate = new Date()
    function getMonth(monthIndex) {
        const accurateMonthIndex = monthIndex >= 0 ? monthIndex % 12 : 12 + monthIndex % 12
        return {
            label: nomeMeses[accurateMonthIndex],
            value: (accurateMonthIndex) + 1,
            ano: new Date().getFullYear() + Math.floor(monthIndex / 12)
        };
    };
    const optionsMes = [
        getMonth(currentDate.getMonth()),
        getMonth(currentDate.getMonth() + 1)
    ];

    const [ filiaisMetas, setFiliaisMetas ] = useState(undefined)

    const [ optionsCluster, setOptionsCluster ] = useState([])
    const [ optionsRegiao, setOptionsRegiao ] = useState([])
    const [ optionsFilial, setOptionsFilial ] = useState([])

    const [ tipoSelecionado, setTipoSelecionado ] = useState(null)
    const [ animalSelecionado, setAnimalSelecionado ] = useState(null)
    const [ mesSelecionado, setMesSelecionado ] = useState(null)
    const [ anoSelecionado,setAnoSelecionado ] = useState(new Date().getFullYear())
    const [ clustersSelecionados, setClustersSelecionados ] = useState(null)
    const [ regioesSelecionadas, setRegioesSelecionadas ] = useState(null)
    const [ filiaisSelecionadas, setFiliaisSelecionadas ] = useState(null);
    const [ metasInputs, setMetasInputs ] = useState(new Array(niveis.length).fill(''))
    const [ pontosInputs, setPontosInputs ] = useState(new Array(niveis.length).fill(''))

    const [ valorBase, setValorBase ] = useState('')
    const [ valorBaseCSVFileName, setValorBaseCSVFileName ] = useState(undefined)
    const [ valorBasePadrao, setValorBasePadrao ] = useState(0)
    const valorBaseCSVRef = useRef(undefined)
    const valorBasePadraoRef = useRef(undefined)

    const [ tipoOrigemCopia, setTipoOrigemCopia ] = useState(0)

    const selectStyle = { 
        control: (base, state) => ({
            ...base,
            background: "unset",
            borderColor: "#DCDCDC",
            borderRadius: "4px"
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }) 
    }

    async function setOptionsTiposWithRequest(authToken) {
        try {
            const tipos = await get('/admin/metas/tipo', null, authToken)         
            const options = tipos.map(tipo => ({ 
                label: tipo.descricao,
                value: tipo.id_tipo_metas
            }))
            setOptionsTipos(options)

            setTipoSelecionado(options.find(option => option.value === TIPO_VENDEDOR))

            return tipos
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsAnimaisWithRequest(authToken) {
        try {
            const animais = await get('/admin/metas/animal', null, authToken)         
            setOptionsAnimais(animais.map(animal => ({ 
                label: animal.nome,
                value: animal.id_animal,
                id_tipo_metas: animal.id_tipo_metas,

                tipo_percentual: animal.tipo_percentual,
                meta_base: animal.meta_base
            })))

            return animais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsClusterWithRequest(authToken) {
        try {
            const clusters = await get('/admin/metas/cluster', null, authToken)
            setOptionsCluster(clusters.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster 
            })))

            return clusters
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const regioes = await get('/admin/metas/regiao', null, authToken);
            setOptionsRegiao(regioes.map(regiao => ({ 
                label: regiao.nome_regiao, 
                value: regiao.id_regiao 
            })));

            return regioes;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsFilialWithRequest(authToken) {
        try {
            const filiais = await get('admin/metas/filial', null, authToken)
            setOptionsFilial(filiais)

            return filiais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey]){
                    if(typeof object[paramKey] === 'object'){
                        return accumulator + object[paramKey].reduce((accumulator2, value) => accumulator2 + `&${paramKey}=${value}` , '')
                    }
                    else return accumulator + `&${paramKey}=${object[paramKey]}`
                }
                    
                else return accumulator
            }, '')
    }
    async function setMetasWithRequest(filtros) {
        try {
            const metas = await get(`/admin/metas?${parseObjectToURLQuery(filtros)}`, null, authTokenState)

            setFiliaisMetas(metas.map(meta => {
                return { 
                    filiais_consultadas: meta.filiais_consultadas.length,
                    idfilial: meta.idfilial,
                    filial_nome: meta.filial_nome,
                    desabilitada: meta.animais[0].desabilitado
                }
            }))

            if(metas.length > 0 && metas.length === metas[0].filiais_consultadas.length){
                let isMetasEquals = metas.every((meta, index) => (
                    index === 0 ||
                    JSON.stringify(meta.animais[0].metas) === JSON.stringify(metas[index - 1].animais[0].metas)
                ))
                
                if(isMetasEquals){
                    const metasGenerais = metas[0].animais[0].metas

                    setMetasInputs(metasGenerais.map(meta => parseFloat(meta.meta).toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 })))
                    setPontosInputs(metasGenerais.map(meta => parseFloat(meta.pontos).toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 })))
                }
                
                if(metas[0].animais[0].valor_base !== null){
                    let isMetaBaseEquals = metas.every((meta, index) => (
                        index === 0 || 
                        meta.animais[0].valor_base === metas[index-1].animais[0].valor_base
                    ))
                    
                    if(isMetaBaseEquals){
                        const metaBaseGeneral = metas[0].animais[0].valor_base

                        setValorBase(parseFloat(metaBaseGeneral).toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 }))
                    }
                }
            }

            return metas
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setAuthTokenState(authToken)
        setOptionsTiposWithRequest(authToken)
        setOptionsAnimaisWithRequest(authToken)
        setOptionsClusterWithRequest(authToken)
        setOptionsRegiaoWithRequest(authToken)
        setOptionsFilialWithRequest(authToken)
    }, [])

    function formatValue(input, type) {
        let formattedValue = input.value

        if(tipoOrigemCopia !== 0)
            return formattedValue

        if(animalSelecionado.value !== ID_JAGUAR && (type === 'meta' || type === 'valorBase')) {
            formattedValue = formattedValue.replace(/[^\d,]/g, '')
            formattedValue = formattedValue.replace(/(?<!\d),/g, '')
            const firstCommaIndex = formattedValue.indexOf(',');
            formattedValue = formattedValue.replace(/,/g, (match, offset) => {
                return offset === firstCommaIndex ? match : '';
            });
        } else {
            formattedValue = formattedValue.replace(/\D/g, '')
        }

        if(formattedValue === '')
            return formattedValue

        if(animalSelecionado.value !== ID_JAGUAR && (type === 'meta' || type === 'valorBase')) {
            if (type === 'meta' && animalSelecionado.tipo_percentual === true) {
                formattedValue = formattedValue.replace(/[^\d,]/g, '');
            
                if (/^00/.test(formattedValue)) {
                    formattedValue = formattedValue.replace(/^00/, '0');
                }
            
                let numericValue = parseFloat(formattedValue.replace(',', '.'));
            
                if (numericValue > 100) {
                    formattedValue = '100';
                } else {
                    if (formattedValue.includes(',')) {
                        let parts = formattedValue.split(',');
                        formattedValue = parts[0] + ',' + parts[1].slice(0, 2); 
                    }
                }
            } else {
                const firstCommaIndex = formattedValue.indexOf(',');
                let preCommas = parseInt(formattedValue.substring(0, firstCommaIndex === -1 ? formattedValue.length : firstCommaIndex));
                if(preCommas > 999999999)
                    preCommas = 999999999;
                const postCommas = firstCommaIndex === -1 ? '' : formattedValue.substring(firstCommaIndex, firstCommaIndex+3)
                
                formattedValue = preCommas.toLocaleString('pt') + postCommas
            }  
        } else {
            formattedValue = parseInt(formattedValue)
            if(formattedValue > 999999999)
                formattedValue = 999999999;
            formattedValue = formattedValue.toLocaleString('pt')
        }
            
        return formattedValue
    }

    function handleInputsChange(index, value, inputsState, setInputsState) {
        const values = [...inputsState] 
        values[index] = value 
        setInputsState(values) 
    };

    const isSecondStageDisabled = (
            filiais=filiaisSelecionadas,
            mes=mesSelecionado, 
            ano=anoSelecionado, 
            animal=animalSelecionado, 
            clusters=clustersSelecionados, 
            regioes=regioesSelecionadas
        ) => (
        animal == null || 
        mes == null ||
        ano == null ||
        ((clusters == null || clusters?.length == 0) &&
        (regioes == null || regioes?.length == 0) &&
        (filiais == null || filiais?.length == 0))
    )

    function isSecondStagePopuled() {
        const pontosNumber = pontosInputs.map(pontos => pontos === '' ? NaN : Number(pontos.replaceAll('.', '')))
        const metasNumber = metasInputs.map(metas => metas === '' ? NaN : Number(metas.replaceAll('.', '').replace(',', '.')))

        return  pontosNumber.every(pontos => !isNaN(pontos) && pontos >= 0) && 
                metasNumber.every(metas => !isNaN(metas) && metas >= 0)
    }


    const isThirdStageDisabled = !animalSelecionado?.meta_base
    const isThirdStageBlocked = typeof filiaisMetas !== 'undefined' && filiaisMetas.length === 0

    function isThirdStagePopuled() {
        const valorBaseNumber = Number(valorBase.replaceAll('.', '').replace(',', '.'))

        return  (!isNaN(valorBaseNumber) && valorBaseNumber != 0) ||
                valorBaseCSVFileName !== undefined || 
                valorBasePadrao !== 0
    }

    const todasFiliasDesabilitadas = typeof filiaisMetas !== 'undefined' && filiaisMetas.length !== 0 && filiaisMetas.filter(filial => filial.desabilitada).length === filiaisMetas[0].filiais_consultadas

    function refreshInputs(type = 'all') {
        switch(type) {
            case 'all':
                setAnimalSelecionado(null)
                setMesSelecionado(null)
                setAnoSelecionado(new Date().getFullYear())

                setClustersSelecionados(null)
                setRegioesSelecionadas(null)
                setFiliaisSelecionadas([])
            case 'valores':
                setTipoOrigemCopia(0)
                setMetasInputs(new Array(niveis.length).fill(''))
                setPontosInputs(new Array(niveis.length).fill(''))
                setFiliaisMetas([])
            case 'metaBase':
                setValorBase('')
                setValorBaseCSVFileName(undefined)
                if(valorBaseCSVRef.current?.value != undefined) valorBaseCSVRef.current.value = null
                setValorBasePadrao(0)
                if(valorBasePadraoRef.current?.value != undefined) valorBasePadraoRef.current.checked = false
        }
    }

    function getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mesSelecionado, anoSelecionado, animalSelecionado) {
        refreshInputs('valores')
        if(!isSecondStageDisabled(filiaisSelecionadas, mesSelecionado, anoSelecionado, animalSelecionado, clustersSelecionados, regioesSelecionadas)){
            setMetasWithRequest({   
                id_clusters: clustersSelecionados,
                id_regioes: regioesSelecionadas,
                idfiliais: filiaisSelecionadas,

                id_animal: animalSelecionado.value,
                id_tipo_metas: tipoSelecionado.value,
                mes: mesSelecionado, 
                ano: anoSelecionado
            });
        }
    }

    function handleRefresh(e, type = 'all') {
        e.preventDefault()

        refreshInputs(type)
    }

    function formatarValoresFilial(valores) {
        if(Array.isArray(valores)){
            const filiais = optionsFilial
                                    .map(option => option.items)
                                    .flat()
                                    .map(filial => filial.value);
            
            const values = valores
                                .map(v => Number(v) + 10000)
                                .filter(v => !isNaN(v))
                                .filter(v => filiais.includes(v));
            
            return values;
        }
        return [];
    }

    async function handleMetasSubmit(event){
        event.preventDefault()

        const idUsuarioAtual = localStorage.getItem("idusuario")
        const authToken = localStorage.getItem("adminToken")

        if(typeof idUsuarioAtual === 'undefined') {
            logout()
        } else{
            /**Validações manuais*/
            if(clustersSelecionados == null && regioesSelecionadas == null && filiaisSelecionadas == null){
                setNotifier(false, "Nenhuma localidade escolhida!")
                return
            }
            /** */

            let valores = niveis.map((nivel) => ({ 
                nivel: nivel, 
                meta: 0, 
                pontos: 0 
            }))
            if(tipoOrigemCopia === 0){
                valores = niveis.map((nivel, index) => ({ 
                    nivel: nivel, 
                    meta: Number(metasInputs[index].replaceAll('.', '').replace(',', '.')), 
                    pontos: Number(pontosInputs[index].replaceAll('.', '').replace(',', '.')) 
                }))

                if(animalSelecionado.tipo_percentual === true) {
                    const niveisWithError = []
                    valores.forEach(valor => {
                        if(valor.meta > 100) {
                            niveisWithError.push(valor.nivel)
                        }
                    })

                    if(niveisWithError.length > 0){
                        const errorValue = niveisWithError.join(', ')
                        setNotifier(false, `Os niveis ${errorValue} estão incorretos! Este animal é percentual, não pode ter valores acima de 100%`)
                        return
                    }
                }

                if(valores.find(valor => valor.meta === 0 || valor.pontos === 0)){
                    const confirmarMetasZeradas = await withReactContent(Swal).fire({
                        title: <i>Atenção!</i>,
                        html: 'Existem valores zerados no cadastro. Deseja prosseguir?',
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        confirmButtonColor: "green",
                    })
    
                    if(!confirmarMetasZeradas.isConfirmed){
                        return;
                    }
                }
            }

            const requisicao = {
                id_clusters: clustersSelecionados,
                id_regioes: regioesSelecionadas,
                idfiliais: filiaisSelecionadas,

                id_tipo_metas: tipoSelecionado.value,
                id_animal: animalSelecionado.value,
                mes: mesSelecionado.value,
                ano: anoSelecionado,
                idusuario: idUsuarioAtual,

                valores: valores,

                tipo_metas_copiar: tipoOrigemCopia
            }

            const { response } = await post('/admin/metas', requisicao, authToken);

            if(response?.status === 500){
                setNotifier(false, response.data.Error)
            }
            else{
                setNotifier(true, 'Metas alteradas com sucesso')
                refreshInputs()
            }
        }
    }

    async function handleValorBaseSubmit(event){
        event.preventDefault();

        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{
            const formData = new FormData(event.target);

            /**Validações manuais*/
            if(clustersSelecionados == null && regioesSelecionadas == null && filiaisSelecionadas == null){
                setNotifier(false, "Nenhuma localidade escolhida!");
                return;
            }

            const valorBaseCSV = formData.get('valorBaseCSV')

            if(valorBase === '' && valorBaseCSVFileName === undefined && valorBasePadrao === 0){
                setNotifier(false, "Nenhuma meta base escolhida!");
                return;
            }
            /** */

            const idclusters = JSON.stringify(clustersSelecionados);
            formData.append('stringifyIdclusters', idclusters);
            const idregioes = JSON.stringify(regioesSelecionadas);
            formData.append('stringifyIdregioes', idregioes);
            const idfiliais = JSON.stringify(filiaisSelecionadas);
            formData.append('stringifyIdfiliais', idfiliais);

            formData.append('id_tipo_metas', tipoSelecionado.value);
            formData.append('id_animal', animalSelecionado.value);
            formData.append('mes', mesSelecionado.value);
            formData.append('ano', anoSelecionado);

            formData.append('idusuario', idUsuarioAtual);

            formData.delete('valorBase');
            if(valorBaseCSV === null || valorBaseCSV.size <= 0 || valorBaseCSVFileName === undefined) {
                formData.append('valorBase', Number(valorBase.replaceAll('.', '').replace(',', '.')));
                formData.delete('valorBaseCSV');
            }

            formData.append('isPadrao', valorBasePadrao);

            const { response } = await post('/admin/metas/valorbase', formData, authToken, { 
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if(response?.status >= 400){
                setNotifier(false, response.data.Error);
                refreshInputs('metaBase');
            }
            else{
                setNotifier(true, 'Metas base alteradas com sucesso');
                getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mesSelecionado.value, anoSelecionado, animalSelecionado);
            }
        }
    }

    function handleCopyValues(event) {
        event.preventDefault();

        switch (tipoSelecionado.value) {
            case TIPO_GERENTE:
                setTipoOrigemCopia(2);
                break;
            case TIPO_VENDEDOR:
                setTipoOrigemCopia(1);
                break;
            default:
                setTipoOrigemCopia(0);
        }

        if([TIPO_GERENTE, TIPO_VENDEDOR].includes(tipoSelecionado.value)){
            setMetasInputs(new Array(niveis.length).fill('Copiado!'));
            setPontosInputs(new Array(niveis.length).fill('Copiado!'));
        }
    }

    async function handleValuesActivity(event) {
        event.preventDefault();

        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{

            const requisicao = {
                id_clusters: clustersSelecionados,
                id_regioes: regioesSelecionadas,
                idfiliais: filiaisSelecionadas,
    
                id_tipo_metas: tipoSelecionado.value,
                id_animal: animalSelecionado.value,
                mes: mesSelecionado.value,
                ano: anoSelecionado,
                idusuario: idUsuarioAtual,
    
                desabilitado: !todasFiliasDesabilitadas
            }
    
            const { response } = await post('/admin/metas/status', requisicao, authToken);
    

            if(response?.status >= 400){
                setNotifier(false, response.data.Error || "Erro interno");
            }
            else{
                setNotifier(true, 'Status da meta foi atualizado!');
                getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mesSelecionado.value, anoSelecionado, animalSelecionado);
            }
        }
    }

    return (
        <>
        <form className='form-gerencia-animal' onSubmit={handleMetasSubmit}>
            <div className='gerencia-animal-first'>
                <div className='header'>
                    <div>
                        <span>1</span>
                        <h1>Selecione os filtros</h1>
                    </div>
                    {filiaisMetas?.filter(filial => filial.desabilitada).length > 0 &&
                        <ToolTipFiliaisDesabilitadas filiais={filiaisMetas?.filter(filial => filial.desabilitada)} todas={todasFiliasDesabilitadas}/>
                    }
                </div>
                <div className='animal-first-values'>
                    <div className='first-values-left'>
                        <div className='id_tipo_metas-wrapper'>
                            <label htmlFor="id_tipo_metas">Selecione o tipo</label>
                            <Select
                                name="id_tipo_metas"
                                className="react-select"
                                classNamePrefix="react-select"
                                value={tipoSelecionado}
                                onChange={(tipo) => { 
                                    setTipoSelecionado(tipo) 

                                    setAnimalSelecionado(null)
                                }}
                                options={optionsTipos}
                                placeholder="Tipo"
                                required
                                isSearchable={false}
                                noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                            />
                        </div>

                        <div className='id_animal-wrapper'>
                            <label htmlFor="id_animal">Selecione o animal</label>
                            <Select
                                name="id_animal"
                                className="react-select"
                                classNamePrefix="react-select"
                                value={animalSelecionado}
                                onChange={(animal) => { 
                                    setAnimalSelecionado(animal) 

                                    getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mesSelecionado?.value, anoSelecionado, animal)
                                }}
                                options={optionsAnimais.filter(option => option.id_tipo_metas === tipoSelecionado?.value)}
                                placeholder="Animal"
                                required
                                isSearchable={false}
                                noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                                menuShouldScrollIntoView={false} 
                            />
                        </div>

                        <div className='mes-wrapper'>
                            <label htmlFor="mes">Selecione o período</label>
                            <Select
                                name="mes"
                                className="react-select"
                                classNamePrefix="react-select"
                                options={optionsMes}
                                value={mesSelecionado}
                                onChange={mes => { 
                                    setMesSelecionado(mes)
                                    setAnoSelecionado(mes.ano) 

                                    getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mes.value, mes.ano, animalSelecionado)
                                }}
                                placeholder="Mês"
                                required
                                menuPortalTarget={document.body} 
                                styles={selectStyle}
                                isSearchable={false}
                                noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                            />
                        </div>

                        <div className='ano-wrapper'>
                            <input 
                                type='text' 
                                name='ano'
                                placeholder='Ano' 
                                value={anoSelecionado}
                                onChange={(value) => setAnoSelecionado(value.currentTarget.value)}
                                required
                                readOnly
                            />
                        </div>
                    </div>
                    <div className='first-values-right'>
                        <div className='id_cluster-wrapper'>
                            <label htmlFor="id_cluster">Selecione o cluster</label>
                            <CustomMultiSelect
                                selectedOptions={clustersSelecionados}
                                setSelectedOptions={setClustersSelecionados}
                                filteredOptions={optionsCluster}
                                placeholder={'Cluster'}
                                disabled={
                                    (regioesSelecionadas != null && regioesSelecionadas?.length > 0) || 
                                    (filiaisSelecionadas != null && filiaisSelecionadas?.length > 0)
                                }
                                onChange={(clusters) => getMetas(clusters, regioesSelecionadas, filiaisSelecionadas, mesSelecionado?.value, anoSelecionado, animalSelecionado)}
                            />
                        </div>

                        <span>ou</span>

                        <div className='id_regiao-wrapper'>
                            <label htmlFor="id_regiao">Selecione a região</label>
                            <CustomMultiSelect
                                selectedOptions={regioesSelecionadas}
                                setSelectedOptions={setRegioesSelecionadas}
                                filteredOptions={optionsRegiao}
                                placeholder='Região'
                                disabled={
                                    (clustersSelecionados != null && clustersSelecionados?.length > 0) || 
                                    (filiaisSelecionadas != null && filiaisSelecionadas?.length > 0) 
                                }
                                onChange={(regioes) => getMetas(clustersSelecionados, regioes, filiaisSelecionadas, mesSelecionado?.value, anoSelecionado, animalSelecionado)}
                            />
                        </div>

                        <span>ou</span>

                        <div className='idfiliais-wrapper'>
                            <label htmlFor="idfiliais">Selecione as filiais</label>
                            <CustomMultiSelectGroup
                                options={optionsFilial}
                                placeholder="Filiais"
                                selectedOptions={filiaisSelecionadas}
                                setSelectedOptions={setFiliaisSelecionadas}
                                className='input-idfiliais'
                                disabled={
                                    (clustersSelecionados != null && clustersSelecionados?.length > 0) || 
                                    (regioesSelecionadas != null && regioesSelecionadas?.length > 0)
                                }
                                doOnChange={(filiais) => getMetas(clustersSelecionados, regioesSelecionadas, filiais, mesSelecionado?.value, anoSelecionado, animalSelecionado)}
                                formatValuesOnFill={formatarValoresFilial}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='gerencia-animal-second'>
                <div className={`header ${isSecondStageDisabled() ? 'disabled' : ''}`}>
                    <div>
                        <span>2</span>
                        <h1>Cadastrar metas</h1>
                    </div>
                    <div className='additional-control-buttons'>
                        <button 
                            className='animal-copy-values' 
                            onClick={handleCopyValues} 
                            disabled={isSecondStageDisabled() || 
                                    todasFiliasDesabilitadas || 
                                    (animalSelecionado != null && !animaisCopiaveis.includes(animalSelecionado.value))}
                        >
                            <CopyAllIcon style={{width: '25px', height: '25px', marginRight: '10px'}} />
                            Copiar indicadores dos {tipoSelecionado?.value === TIPO_GERENTE ? 'vendedores' : 'gerentes'}
                        </button>
                        <button 
                            className={`animal-cancel-values ${todasFiliasDesabilitadas ? 'ativar' : 'desabilitar'}`}
                            onClick={handleValuesActivity}
                        >
                            {todasFiliasDesabilitadas 
                                ?   <>
                                        <CheckIcon style={{width: '25px', height: '25px', marginRight: '10px'}} />
                                        <span>Habilitar indicador nestas filiais</span>
                                    </>
                                :   <>
                                        <BlockIcon style={{width: '25px', height: '25px', marginRight: '10px'}} />
                                        <span>Desabilitar indicador nestas filiais </span>
                                    </>
                            }
                        </button>
                    </div>
                </div>
                <div className={`body ${isSecondStageDisabled() || todasFiliasDesabilitadas  ? 'disabled' : ''}`}>
                    {niveis.map((nivel, index) => (
                        <div key={nivel} className={`gerencia-animal-meta nivel-${nivel}`}>
                            <h2>Nível {nivel}</h2>
                            <div>
                                <div className='meta-wrapper'>
                                    <label htmlFor="meta">Meta:</label>
                                    <input type="text" value={metasInputs[index]} required
                                    onChange={(event) => {
                                        const value = formatValue(event.target, 'meta')
                                        handleInputsChange(index, value, metasInputs, setMetasInputs)
                                    }} disabled={tipoOrigemCopia !== 0}/>
                                </div>
                                <div className='pontos-wrapper'>
                                    <label htmlFor="pontos">Pontos:</label>
                                    <input type="text" value={pontosInputs[index]} required
                                    onChange={(event) => { 
                                        const value = formatValue(event.target, 'pontos')
                                        handleInputsChange(index, value, pontosInputs, setPontosInputs)
                                    }} disabled={tipoOrigemCopia !== 0}/>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='animal-metas-buttons'>
                    <button className='animal-refresh-btn' 
                    disabled={isSecondStageDisabled() || 
                        !isSecondStagePopuled() ||
                        todasFiliasDesabilitadas
                    }
                    onClick={(e) => handleRefresh(e)}>Cancelar</button>
                    <button className='animal-save-btn' 
                        disabled={isSecondStageDisabled() || 
                            !isSecondStagePopuled() ||
                            todasFiliasDesabilitadas
                        }
                    >Salvar</button>
                </div>
            </div>
        </form>
        {!isSecondStageDisabled() && !isThirdStageDisabled && isThirdStageBlocked && 
            <span className="gerencia-animal-third-blocked">
                <WarningAmberIcon style={{width: '50px', height: '50px', marginBottom: '5px'}} />
                <span>Atenção: Registre primeiramente as metas para que então possa editar a meta base</span>
            </span>
        }
        <form className={`gerencia-animal-third ${isSecondStageDisabled() || isThirdStageDisabled || isThirdStageBlocked ? 'disabled' : ''}`} onSubmit={handleValorBaseSubmit}>
            <div className={`header ${todasFiliasDesabilitadas ? 'disabled' : ''}`}>
                <span>3</span>
                <h1>Escolher meta base</h1>
            </div>
            <div className={`body ${todasFiliasDesabilitadas  ? 'disabled' : ''}`}>
                <div className='values'>
                    <div className='valorBase-wrapper'>
                        <label htmlFor="valorBase">Meta base:</label>
                        <input type="text" name='valorBase' value={valorBase} onChange={(e) => {
                            const value = formatValue(e.target, 'valorBase')
                            setValorBase(value)
                        }} disabled={valorBaseCSVFileName !== undefined || valorBasePadrao !== 0}
                        />
                    </div>

                    {!semMetaBaseSistema.includes(animalSelecionado?.value) && 
                        <>
                        <span>ou</span>

                        <div className='valorBasePadrao-wrapper'>
                            <input type="checkbox" ref={valorBasePadraoRef} name='valorBasePadrao' id="valorBasePadrao" onChange={() => {
                                setValorBasePadrao(1)
                            }} disabled={valorBase != '' || valorBaseCSVFileName !== undefined || valorBasePadrao === 1}/>
                            <label htmlFor="valorBasePadrao" className={valorBase != '' || valorBaseCSVFileName !== undefined ? 'disabled' : ''}>
                                <SettingsSystemDaydreamIcon style={{width: '25px', height: '25px', marginRight: '10px'}} />
                                Importar padrão do sistema
                            </label>
                        </div>
                        </>
                    }

                    <span>ou</span>

                    <div className='valorBaseCSV-wrapper'>
                        <label htmlFor="valorBaseCSV" className={valorBase != '' || valorBasePadrao !== 0 ? 'disabled' : ''}>{valorBaseCSVFileName === undefined ? 'Importar CSV' : valorBaseCSVFileName}</label>
                        <input type="file" accept='.csv' ref={valorBaseCSVRef} name='valorBaseCSV' id="valorBaseCSV" onChange={(e) => {
                            const uploadedFile = e.target.files[0];
                            if (uploadedFile) {
                                setValorBaseCSVFileName(uploadedFile.name);
                            }
                        }} disabled={valorBase != '' || valorBasePadrao !== 0}/>
                        <a className="my-anchor-element">&#10067;</a>
                    </div>
                </div>
                <div className='animal-valorBase-buttons'>
                    <button 
                        className='animal-refresh-btn' 
                        onClick={(e) => handleRefresh(e, 'metaBase')}>Limpar</button>
                    
                    <button className='animal-save-btn' disabled={!isThirdStagePopuled()}>Salvar meta base</button>
                </div>
            </div>
            <Tooltip anchorSelect=".my-anchor-element" place="top">
                <img src={imagemExemplo} alt="Exemplo" width={"300px"}/>
            </Tooltip>
        </form>
        </>
    )
}

export default CadastroMetas